"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUserBirthdayToDate = void 0;
const legacy_config_1 = require("@daytrip/legacy-config");
function transformUserBirthdayToDate(birthdayAt) {
    return birthdayAt ?? new Date(legacy_config_1.DEFAULT_BIRTHDAY_AT);
}
exports.transformUserBirthdayToDate = transformUserBirthdayToDate;
//# sourceMappingURL=transformUserBirthdayToDate.js.map